import DateBox from "devextreme/ui/date_box";

DateBox.defaultOptions({
  options: {
    displayFormat: "ddMMyyyy",
    useMaskBehavior: true,
    onFocusIn: (e) => {
      if (e.event.target.select) e.event.target.select();
    },
  },
});
